import React from 'react';
import { Zap, Scale, Brain } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const SPEED_ICON = { fast: Zap, balanced: Scale, thoughtful: Brain };

// Dropdown over the ChatGPT model catalogue. `value` is a model id.
export const ModelPicker = ({ models, value, onChange, disabled = false, compact = false, testId = 'model-picker', label = 'Model' }) => {
  const current = models.find((m) => m.id === value);
  return (
    <Select value={value || ''} onValueChange={onChange} disabled={disabled || !models.length}>
      <SelectTrigger className={`model-picker ${compact ? 'compact' : ''}`} aria-label={label} data-testid={testId}>
        <SelectValue placeholder="Model">
          {current ? (
            <span className="model-picker-value">
              <span className="model-dot" aria-hidden="true" />
              {current.name}
            </span>
          ) : 'Model'}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="model-picker-menu" align="end">
        {models.map((m) => {
          const Icon = SPEED_ICON[m.speed] || Scale;
          return (
            <SelectItem key={m.id} value={m.id} className="model-option" data-testid={`model-option-${m.id}`}>
              <span className="model-option-row">
                <Icon size={14} className="model-option-icon" aria-hidden="true" />
                <span className="model-option-text">
                  <span className="model-option-name">{m.name}</span>
                  <span className="model-option-tagline">{m.tagline}</span>
                </span>
              </span>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
